import { createReducer, on } from '@ngrx/store';
import {
  loadProvincesFailure,
  loadProvincesSuccess,
  toggleProvincesLoading,
} from './provinces.actions';
import { initialUIState } from './provinces.state';

export const provincesReducer = createReducer(
  initialUIState,
  on(toggleProvincesLoading, (state, { isLoading }) => ({
    ...state,
    isLoading,
  })),
  on(loadProvincesSuccess, (state, { provinces }) => ({
    ...state,
    list: provinces,
    isLoading: false,
  })),
  on(loadProvincesFailure, (state) => ({
    ...state,
    isLoading: false,
  })),
);